
export const menulist = [
    {
        id: "home",
        path: "/",
        icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-svg-img" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgHome" aria-hidden="true"><path d="M4.75 10.75v9a1.16 1.16 0 00.213.725.717.717 0 00.587.275h12.4a.737.737 0 00.55-.275 1.1 1.1 0 00.25-.725v-9m-16 2l4.5-5 4.5-5 4.5 5 4.5 5m-11.5 8v-5a.945.945 0 011-1h3a.945.945 0 011 1v5"></path></svg>,
        name: "Home",
    },
    {
        id: "course",
        path: "/course",
        icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-svg-img" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgBookOpen" aria-hidden="true"><path d="M12 17.95V7.65m0 0a6.307 6.307 0 00-2.075-1.263A7.251 7.251 0 007.4 5.95a7.064 7.064 0 00-2.425.425A6.008 6.008 0 003 7.55v10.4a6.008 6.008 0 011.975-1.175A7.064 7.064 0 017.4 16.35a6.978 6.978 0 012.525.475A7.457 7.457 0 0112 18.05m0-10.4a6.307 6.307 0 012.075-1.263A7.251 7.251 0 0116.6 5.95a7.064 7.064 0 012.425.425A6.008 6.008 0 0121 7.55v10.4a6.008 6.008 0 00-1.975-1.175 7.064 7.064 0 00-2.425-.425 6.978 6.978 0 00-2.525.475A7.457 7.457 0 0012 18.05"></path></svg>,
        name: "Cursos",
    },
    {
        id: "profile",
        path: "/profile",
        icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-svg-img" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" viewBox="0 0 24 24" data-icon="SvgUserShield" aria-hidden="true"><path d="M7.619 19.992A10 10 0 012 11V5a2 2 0 012-2h16a2 2 0 012 2v2.927m-7.542 10.738h-.128a2.89 2.89 0 00-2.89 2.89V23m8.542-4.335h-5.524M23 23v-1.445a2.89 2.89 0 00-2.89-2.89h-.128"></path><circle cx="17.22" cy="12.885" r="2.89"></circle></svg>,
        name: "Perfil",
    },
    {
        id: "novedades",
        path: "/novedades",
        icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-svg-img" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgRss" aria-hidden="true"><path d="M12.288 21.009a10.338 10.338 0 00-9.231-9.29M21 21A18 18 0 003 3m.036 17.964l-.08.061.088-.067"></path></svg>,
        name: "Novedades",
    },
    {
        id: "contact",
        path: "/contact",
        icon: <svg xmlns="http://www.w3.org/2000/svg" className="nav-svg-img" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgMail" aria-hidden="true"><path d="M21.75 4.5H2.25a1.5 1.5 0 00-1.5 1.5v12a1.5 1.5 0 001.5 1.5h19.5a1.5 1.5 0 001.5-1.5v-12a1.5 1.5 0 00-1.5-1.5zm-19.5 2l9 6 9-6m-9 6V20"></path></svg>,
        name: "Contacto",
    },
    {
        id: "about",
        path: "/about",
        icon: '',
        name: "Nosotras",
    },
    {
        id: "login",
        path: "/login",
        icon: '',
        name: "Iniciar Sesión",
    }
]